











































import Vue, { PropType } from 'vue';
import TableLight from '@/components/table/TableLight.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import { DropdownList } from '@/types';
import { Column } from '@/components/table/types';
import { IDefaultSort } from '@/types/dashboard';

export default Vue.extend({
  name: 'TableWidget',
  components: { TableLight, FieldSelect, Preloader },

  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    columns: {
      type: Array as PropType<Array<Column>>,
      required: true,
      default: () => [],
    },
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectOptions: {
      type: Array as PropType<Array<DropdownList>>,
      required: true,
      default: () => [],
    },
    defaultSort: {
      type: Object as PropType<IDefaultSort>,
      required: false,
      default: null
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  watch: {
    currentField() {
      this.changeSelect();
    },
    selectOptions(newValue) {
      this.currentField = newValue[0].value;
    },
  },

  computed: {
    currentSelectedOption(): DropdownList {
      return (
        this.selectOptions.find((s) => s.value === this.currentField) ||
        this.selectOptions[0]
      );
    },
  },

  methods: {
    changeSelect() {
      this.$emit('changeSelect', this.currentField);
    },
    changeSort(sortData) {
      this.currentSort = sortData;
      this.$emit('changeSort', sortData);
    },
  },

  data() {
    return {
      currentField: this.selectOptions[0].value,
      currentSort: null,
    };
  },
});
